export enum Mode {
    Anim = 'anim',
    Auto = 'auto',
    Demo = 'demo',
}
